import { Directive, ViewContainerRef, Component, ElementRef, AfterViewInit, ChangeDetectorRef, ViewChild, Input, OnInit, HostListener, ComponentFactoryResolver } from '@angular/core';
import {FormControl, FormGroupDirective, NgForm, Validators} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { StudentService, AlertService, ExamService} from '../_services'; 
import { first } from 'rxjs/operators';
import { Globals } from '../_helpers';
import { OpentokService } from '../_services/opentok.service';
import swal, { SweetAlertOptions } from 'sweetalert2';
import { SwalComponent } from '@toverux/ngx-sweetalert2';
import config from '../../config';
import { SubscriberComponent } from '../subscriber/subscriber.component';
import {Subject, Observable} from 'rxjs';
import {WebcamImage, WebcamInitError, WebcamUtil} from 'ngx-webcam';
import { NgxSpinnerService } from 'ngx-spinner';

const publish = () => {

};

@Component({
  selector: 'app-video-conf',
  templateUrl: './video-conf.component.html',
  styleUrls: ['./video-conf.component.css']
  //providers: [ OpentokService ]  
})
export class VideoConfComponent implements AfterViewInit, OnInit {
  @ViewChild('publisherDiv') publisherDiv: ElementRef;
  @ViewChild('subscriberHost', { read: ViewContainerRef }) subscriberHost: ViewContainerRef;
  @ViewChild('timeoverSwal') private timeoverSwal: SwalComponent;
  @ViewChild('keysExpireSwal') private keysExpireSwal: SwalComponent;
  @ViewChild('entermarkSwal') private entermarkSwal: SwalComponent;
  @ViewChild('setmarkSwal') private setmarkSwal: SwalComponent;  
  @ViewChild('practicalOverSwal') private practicalOverSwal: SwalComponent;  
  public alertOption: SweetAlertOptions = {};
  marksFormControl = new FormControl('', [
      
  ]);
  publisher: OT.Publisher;
  publishing: Boolean;
  timershow: string;
  feeds: any;
  loading = false;
  submitted = false;
  returnUrl: string;
  imagePath: string;
  std_data: any;
  interval;
  settime;
  isPause = false;
  sess: string
  public showWebcam = true;
  public deviceId: string;
  ssclogo: string = '';
  totalQuestion: number;
  questArr = [];
  students = [];
  studentName: string
  studentCode: string
  feed: any;
  localData = {};
  authenticationService: any;
  session: OT.Session;
  //streams: Array<OT.Stream> = [];
  changeDetectorRef: ChangeDetectorRef;
  timesession: string;
  maxMarks: number;
  vcsettings = {};

  answerdObj = {};
  isMedia = false;
  qaudioUrl: string = ''; 
  qvideoUrl: string = '';
  qimageUrl: string = ''; 
  isDone = false; 
  currentIndex = 0;
  duration : number = 0;
  id_qb_question : number = 0;
  photo:string;
  subject: string;
  type : string;  
  question : string;
  questionInst: string;
  index : number = 0;
  answer_id: number; 
  chapter_id: number; 
  instructions = []; 
  nos: string = ''; 
  assessorName;
  constructor(private route: ActivatedRoute,
    private router: Router,
    private studentService: StudentService,
    private alertService: AlertService,
    private examService: ExamService,
    private globals: Globals,
    private ref: ChangeDetectorRef,
    private spinner: NgxSpinnerService,
    private opentokService: OpentokService,
    private componentFactoryResolver: ComponentFactoryResolver,
  ) {
    this.changeDetectorRef = ref;
    //this.publishing = false;
  }

  hangup: string
  practical_id:number
  student_id:number

  ngOnInit() {
    this.localData = JSON.parse(localStorage.getItem('currentUser'));
    this.assessorName = this.localData['name_assessor'];    
    this.returnUrl = '/';
    this.std_data = JSON.parse(sessionStorage.getItem('pkshn_vc_settings'));
    this.timesession = this.std_data['timesession'];
    this.maxMarks = this.std_data['maxmarks'];
    this.vcsettings = JSON.parse(sessionStorage.pkshn_vc_settings);
    this.hangup = '/assets/images/end1.jpg'
    this.student_id=this.std_data['student_id'];
    this.practical_id=this.std_data['practical_id'];
    /* call function for first question and exam info */
    this.getPracticalExams();
    this.counter(this.timesession);
  }
    /* Get Exam data when exam UI is load */
    private getPracticalExams(){
        this.loading = true;
        this.spinner.show();
        this.questArr= [];
        this.answerdObj = {};
        this.isMedia = false;
        this.qaudioUrl = ''; 
        this.qvideoUrl = '';
        this.qimageUrl = '';
        this.examService.getVCFirstQuestion(this.globals.root_url, this.localData['usercode'], this.student_id, this.localData['exam_id'], this.index)
        .pipe(first())
        .subscribe(
            data => {
                if(data.code == 1000){
                    let exam = data;
                    this.duration = exam.duration;
                    this.photo =exam.exam_logo;
                    //this.type = exam.type;
                    this.totalQuestion = exam.total_question;
                    let questionData = exam.question[0];
                    this.id_qb_question = questionData.id_qb_question;
                    this.chapter_id = questionData.id_chapter;
                    this.question = questionData.question;
                    this.questionInst = questionData.question_instruction;
                    this.maxMarks = questionData.question_mark;
                    this.nos = questionData.nos;
                    this.subject = questionData.subject_name;
                    //if(questionData.index == 1)
                    //  this.index = questionData.index + 1;
                   // else
                      this.index = questionData.index;
                    if(questionData.media != ''){
                        this.isMedia = false; //true
                        if(questionData.media_type == 2){
                            this.qimageUrl = questionData.media;
                        }
                        else if(questionData.media_type == 3){
                           this.qaudioUrl = questionData.media; 
                        }
                        else if(questionData.media_type == 4){ 
                            this.qvideoUrl = questionData.media;
                        }
                    } 
                   this.loading = false;                 
                   this.spinner.hide();
                }
                else if(data.code == 1001)
                {
                      this.loading = false;  
                      this.spinner.hide();
                     this.practicalOverSwal.show(); 
                }
                else if(data.status == 'COM_TOKEN_ERROR'){
                    this.loading = false;
                    this.router.navigateByUrl('/login');
                    this.spinner.hide();
                }
                else{
                    this.loading = false;
                    //this.router.navigateByUrl('/login');
                    this.spinner.hide();
                }
                
            },
            error => {
                this.alertService.error(error);
                this.loading = false;
                //this.router.navigateByUrl('/login');
                this.spinner.hide();
            }
        );
    }
  public nextQuestion() {
   // if (this.index < this.totalQuestion) {
   //   this.saveAndNext('next', this.anstype)
  //  }
    //else {
        //this.submitSingleQuestion(this.index, this.question_id);
   // }
    if(this.marksFormControl.value == "")
    {
      this.setmarkSwal.show(); 
      return;   
    }
    else if(this.marksFormControl.value > this.maxMarks) 
    {
      this.marksFormControl.setValue(''); 
      this.entermarkSwal.show(); 
      return;          
    } 
    this.submitSingleQuestion(this.index, this.id_qb_question);
  } 
  /* submit single question with lock*/
  public submitSingleQuestion(index, question_id) {
    this.loading = true;
    this.spinner.show();
    this.examService.setVCQuestionByIndex(this.globals.root_url, this.localData['usercode'], this.localData['id'], this.student_id, this.practical_id, index, question_id, this.marksFormControl.value, this.maxMarks, this.localData['exam_id'], this.chapter_id)
      .pipe(first())
      .subscribe(
        data => {
          if (index == this.totalQuestion) {
            this.loading = false;
            this.spinner.hide();            
            this.marksFormControl.setValue(''); 
            this.practicalOverSwal.show();
            this.endPractical();             
          }
          else if (data.code == 1000) {
              this.getPracticalExams();
              this.spinner.hide();
              this.marksFormControl.setValue(''); 
          }
          else {
            this.loading = false;
            //this.router.navigateByUrl('/login');
          }
         // this.spinner.hide();
        },
        error => {
          this.alertService.error(error);
          this.loading = false;
          this.router.navigateByUrl('/login');
          this.spinner.hide();
        }
      );
  }   
  
  publish() {
   this.session.publish(this.publisher, (err) => {
      if (err) {
        console.log(err)
      }
      else {
        this.publishing = true;

      }
    });
  }

  onStreamCreated(stream) {
   const componentFactory = this.componentFactoryResolver.resolveComponentFactory(SubscriberComponent);

    const viewContainerRef = this.subscriberHost;
    this.counter(this.timesession);

    const componentRef = viewContainerRef.createComponent(componentFactory);
    (<SubscriberComponent>componentRef.instance).stream = stream;
    (<SubscriberComponent>componentRef.instance).session = this.session;
    (<SubscriberComponent>componentRef.instance).subscribe();
  }
  ngAfterViewInit(): void {
    this.publisher = OT.initPublisher
      (

        this.publisherDiv.nativeElement, {
        height: "250px",
        width: "320px",
        insertMode: 'append'
      });
    this.session = OT.initSession(config.API_KEY, this.std_data['s_id']);
    this.session.connect(this.std_data['t_id'], (err) => {
      if (err) {
        console.log(err);
      }
      else {
        console.log("connected");
        this.publish()
        let that = this;
        this.session.on("streamCreated", function (event) {
          that.onStreamCreated(event.stream);          
        });
        this.session.on("streamDestroyed", function (event) {
          console.log("The publisher stopped streaming. Reason: "+ event.reason);       
        }); 
        this.session.on("sessionDisconnected", function (event) {
          console.log("The publisher disconnect streaming");   
          this.publisher.publishAudio(false); 
          this.publisher.publishVideo(false);              
        });             
      }
    })
  }
  private counter(timesession) {
      var minutes = parseInt(timesession);
      var seconds = 0;
       this.timershow = minutes + ':' + seconds;

      this.interval = setInterval(() => {
        if (!this.isPause) {
          --seconds;
          minutes = (seconds < 0) ? --minutes : minutes;
          seconds = (seconds < 0) ? 59 : seconds;
          if (minutes == 5 && seconds == 0) {
            document.getElementById('timer-id').classList.add('blink_me');
          }
          if (minutes <= 0 && seconds <= 0 && this.isDone == false) {
            clearInterval(this.interval);
            this.timeoverSwal.show();
            this.endPractical()
            this.settime = setTimeout(function () {
              this.timeoverSwal.hide();
            }, 200);
          }
          this.timershow = minutes + ':' + seconds;
        }
      }, 1000);      
  }
  public audioOnOff(btnIndex) {
    if (document.getElementById('btn-' + btnIndex).classList.contains('img_mike') == true) {
      document.getElementById('btn-' + btnIndex).classList.remove("img_mike");
      document.getElementById('btn-' + btnIndex).classList.add("img_mikes");
      this.publisher.publishAudio(true);
    }
    else {
      document.getElementById('btn-' + btnIndex).classList.add("img_mike");
      this.publisher.publishAudio(false);
    }
  }
  public videoOnOff(btnIndex) {
    if (document.getElementById('btn-' + btnIndex).classList.contains('img_mike') == true) {
      document.getElementById('btn-' + btnIndex).classList.remove("img_mike");
      document.getElementById('btn-' + btnIndex).classList.add("img_mikes");
      this.publisher.publishVideo(true);
    }
    else {
      document.getElementById('btn-' + btnIndex).classList.add("img_mike");
      this.publisher.publishVideo(false);
    }
  }
  public subsaudioOnOff(btnIndex) {
    if (document.getElementById('btn-' + btnIndex).classList.contains('img_mike') == true) {
      document.getElementById('btn-' + btnIndex).classList.remove("img_mike");
      document.getElementById('btn-' + btnIndex).classList.add("img_mikes");
      this.publisher.publishAudio(true);
    }
    else {
      document.getElementById('btn-' + btnIndex).classList.add("img_mike");
      this.publisher.publishAudio(false);
    }
  }


  isError = false
  errorMsg: string

  public endPractical() {
    this.toggleWebcam()
    this.studentService.endPractical(this.globals.root_url, this.localData['usercode'], this.localData['id'], this.localData['exam_id'], this.std_data['student_id'], this.std_data['practical_id'])
      .pipe(first())
      .subscribe(
        data => {
          if (data.code == 1000) {
            this.showWebcam = false;
            this.toggleWebcam();
            clearInterval(this.interval); 
            //this.publisher.publishAudio(false); 
            //this.publisher.publishVideo(false);              
            this.router.navigate(['/marks', this.practical_id, this.student_id])
            // this.marks(this.std_data['practical_id'],this.std_data['student_id'])
          }
          else if (data.code == 1001) {
            this.isError = true;
            this.errorMsg = 'You do not have any Particular. !!';
          }

        }
      )
  }

  public toggleWebcam() {
    this.showWebcam = !this.showWebcam;
      
  }
   redirectList(){
     this.isDone = true;
     //clearInterval(this.interval);
    this.endPractical();
/*    this.settime = setTimeout(function () {
      this.router.navigateByUrl(['/practical-list', this.practical_id, this.student_id]);
    }, 200);*/

   }

  // public marks(practical_id:number,student_id:number){
  //   this.router.navigate(['/marks',this.std_data['practical_id'],this.std_data['student_id']])



  // }






}